import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('seicon_admin_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      // Token expired/invalid — clear and let UI handle redirect
      localStorage.removeItem('seicon_admin_token');
    }
    return Promise.reject(e);
  }
);

/** Build a fully-qualified URL for backend-served images (uploads). */
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
  if (url.startsWith('/api/uploads/') || url.startsWith('/uploads/')) {
    return `${BACKEND_URL}${url.startsWith('/api') ? '' : '/api'}${url.startsWith('/api') ? url.slice(4) : url}`;
  }
  return url;
};

// Simpler: any path beginning with / is treated as same-origin via BACKEND_URL
export const fileUrl = (url) => {
  if (!url) return '';
  if (/^(https?:|data:)/.test(url)) return url;
  return `${BACKEND_URL}${url}`;
};
